// SceltaVoce.tsx — v026: la griglia delle voci buffe (in partita e nella partita a 4). Gli altri sentono la voce
// cambiata; tu senti la tua di sempre.
import { useTranslation } from "react-i18next";
import { tastiRadio } from "../componenti/tastiRadio.ts";
import { VOCI, type Voce } from "./voce.ts";

// v046: voci nuove (l'ordine della griglia è quello di VOCI: prima le più divertenti)
const FACCINE: Record<Voce, string> = {
  normale: "🙂",
  elio: "🎈",
  orco: "👹",
  donna: "👩",
  uomo: "🧔",
  papera: "🦆",
  scoiattolo: "🐿️",
  gigante: "🐘",
  robot: "🤖",
  alieno: "👽",
  nonnina: "👵",
  fantasma: "👻",
  sottacqua: "🐠",
  eco: "🏔️",
  radio: "📻",
};

export function SceltaVoce({ attiva, onScegli }: { attiva: Voce; onScegli: (v: Voce) => void }) {
  const { t } = useTranslation();
  return (
    <div className="ld-voci-scelta">
      <div className="ld-voci" role="radiogroup" aria-label={t("voce.titolo")} onKeyDown={tastiRadio}>
        {VOCI.map((v) => (
          <button key={v} type="button" role="radio" aria-checked={v === attiva} tabIndex={v === attiva ? 0 : -1} className="ld-voce" data-voce={v} onClick={() => onScegli(v)}>
            <span className="ld-voce-faccina" aria-hidden="true">
              {FACCINE[v]}
            </span>
            <span className="ld-voce-nome">{t(`voce.${v}`)}</span>
          </button>
        ))}
      </div>
      <p className="nota-centrata">{t("voce.nota")}</p>
    </div>
  );
}

/** L'icona del pulsante «voce» (un microfono con le onde). */
export function IconaVoce() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
    </svg>
  );
}
